import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  Box: {
    width: '400px',
    background: 'var(--Base-White, #FFF)',
    borderRadius: '12px',
    boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
  },
  BoxHeader: {
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'stretch',
    background: 'var(--Base-White, #FFF)',
  },
  BoxContent: {
    display: 'flex',
    padding: '0px 16px',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
    flexWrap: 'wrap',
  },
  BoxFooter: {
    display: 'flex',
    padding: ' 24px 16px 16px 16px',
    alignItems: 'flex-start',
    gap: '12px',
    flex: '1 0 0',
  },
  BoxTitleModal: {
    borderRadius: '12px',
    display: 'flex',
    padding: ' 20px 16px 16px 16px',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
    background: 'var(--Base-White, #FFF)',
    alignSelf: 'stretch',
  },
  TitleModal: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignSelf: 'stretch',
  },
  Icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
  },
}));

const cancelButtonStyle = {
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '24px',
  borderRadius: '8px',
  color: 'var(--Gray-700, #344054)',
  border: '1px solid var(--Gray-300, #D0D5DD)',
  background: 'var(--Base-White, #FFF)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: '#FFF' },
};

const confirmButtonStyle = {
  borderRadius: '8px',
  border: '1px solid #30893C',
  background: '#30893C',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  color: 'var(--Base-White, #FFF)',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '24px',
  '&:hover': { backgroundColor: '#30893C' },
};

const warningButtonStyle = {
  borderRadius: '8px',
  border: '1px solid #912018',
  background: '#912018',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  color: 'var(--Base-White, #FFF)',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '24px',
  '&:hover': { backgroundColor: '#912018' },
};

export { cancelButtonStyle, confirmButtonStyle, useStyles, warningButtonStyle };

